import React from 'react';

export default function NotFound() {
    return (
        <div className="mt-5 flex ">
            <div className="m-auto space-y-8 px-4">
                De tour is niet gevonden.<br/>
            </div>
        </div>
    );
}